// extracted by mini-css-extract-plugin
export var imageWrapper = "contact-card-module--image-wrapper--bJaj9";
export var image = "contact-card-module--image--BcLm-";
export var itemWrapper = "contact-card-module--item-wrapper--edj-B";
export var icon = "contact-card-module--icon--SSoWy";